﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VXSManagerV2Contract = exports.VXStrategyInfo = exports.VXStrategyScope = exports.VXStrategyBotConfig = void 0;
const ContractFacade_1 = require("./abstact/ContractFacade");
const VXSManagerV2ABI_1 = require("./abi/VXSManagerV2ABI");
class VXStrategyBotConfig {
}
exports.VXStrategyBotConfig = VXStrategyBotConfig;
class VXStrategyScope {
    static NewEmpty() {
        const scope = new VXStrategyScope();
        scope.rateUPLS = scope.uPLSInStake = scope.PLSToSwap = scope.lastSplitTimestamp =
            scope.swapMinPLSAmount = scope.swapMaxPLSAmount = scope.sendPLSIndex = scope.bnsIndex = "0";
        scope.swapRouterV2 = scope.sendPLSReceiver = scope.sendAddress = VXStrategyScope.ZeroAddress;
        scope.swapPath = [];
        scope.isBurnWithERC20Burn = false;
        return scope;
    }
}
exports.VXStrategyScope = VXStrategyScope;
VXStrategyScope.ZeroAddress = "0x0000000000000000000000000000000000000000";
//address owner_, uint version_, IVXS.Scope memory scope_, uint upls_, uint pls_, uint withdrawalPLS_
class VXStrategyInfo {
}
exports.VXStrategyInfo = VXStrategyInfo;
class VXSManagerV2Contract extends ContractFacade_1.ContractFacade {
    constructor(address, web3) {
        super(address, web3, VXSManagerV2ABI_1.VXSManagerV2ABI.GetABI());
    }
    configureBotAsync(config) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this._send('configureBot', [
                this._toWei(config.swapMaxSlippageIndex),
                config.swapFrequencySeconds + "",
                config.splitFrequencySeconds + "",
                this._toWei(config.splitMinProfitAmount),
                this._toWei(config.maxGasAmount)
            ]);
            return result;
        });
    }
    configureAsync(scope, migration) {
        return __awaiter(this, void 0, void 0, function* () {
            const _scope = [
                "0",
                this._toWei(scope.uPLSInStake),
                "0",
                "0",
                scope.swapRouterV2,
                scope.swapPath,
                this._toWei(scope.swapMinPLSAmount),
                this._toWei(scope.swapMaxPLSAmount),
                this._toWei(scope.sendPLSIndex),
                scope.sendPLSReceiver,
                this._toWei(scope.bnsIndex),
                scope.sendAddress,
                scope.isBurnWithERC20Burn
            ];
            if (migration) {
                _scope[0] = this._toWei(scope.rateUPLS);
                _scope[2] = this._toWei(scope.PLSToSwap);
                _scope[3] = scope.lastSplitTimestamp;
            }
            const result = yield this._send('configure', _scope, migration);
            return result;
        });
    }
    withdrawUPLS(uPLSAmountETH) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this._send('withdrawUPLS', this._toWei(uPLSAmountETH));
            return result;
        });
    }
    withdrawPLS() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this._send('withdrawPLS');
            return result;
        });
    }
    getStrategyAdr(ownerAdr) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._call("getStrategyAdr", ownerAdr);
        });
    }
    getFeed(strategyAdr) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this._call("getFeed", strategyAdr);
            return this._toDecimal(result);
        });
    }
    getStrategy(strategyAdr) {
        return __awaiter(this, void 0, void 0, function* () {
            let result = yield this._call("getStrategy", strategyAdr);
            if (!result)
                return;
            result.scope_.rateUPLS = this._toDecimal(result.scope_.rateUPLS);
            result.scope_.uPLSInStake = this._toDecimal(result.scope_.uPLSInStake);
            result.scope_.PLSToSwap = this._toDecimal(result.scope_.PLSToSwap);
            result.scope_.lastSplitTimestamp = result.scope_.lastSplitTimestamp;
            result.scope_.swapMinPLSAmount = this._toDecimal(result.scope_.swapMinPLSAmount);
            result.scope_.swapMaxPLSAmount = this._toDecimal(result.scope_.swapMaxPLSAmount);
            result.scope_.sendPLSIndex = this._toDecimal(result.scope_.sendPLSIndex);
            result.scope_.bnsIndex = this._toDecimal(result.scope_.bnsIndex);
            return result;
            // const result = await this._call("configs", ofAddress);
            // if (!result) return;
            // result.swapMaxSlippageIndex = this._toDecimal(result.swapMaxSlippageIndex);
            // result.swapFrequencySeconds = parseInt(result.swapFrequencySeconds);
            // result.splitFrequencySeconds = parseInt(result.splitFrequencySeconds);
            // result.splitMinProfitAmount = this._toDecimal(result.splitMinProfitAmount);
            // result.maxGasAmount = this._toDecimal(result.maxGasAmount);
            // return result;
        });
    }
}
exports.VXSManagerV2Contract = VXSManagerV2Contract;
//# sourceMappingURL=VXSManagerV2Contract.js.map